<script lang="ts" setup>
  import mjloopbutton from "./mjloopbutton.vue";
  import mjloopktext from "./mjlooptext.vue";
  import mjloopimage from "./mjloopimage.vue";
  import { h as createElement } from "vue";

  const props = defineProps({
    block: {
      type: Object,
      required: true,
    },
    columnIndex: {
      type: Number,
      required: true,
    },
    sectionIndex: {
      type: Number,
      required: true,
    },
    blockIndex: {
      type: Number,
      required: true,
    },
    loopColumnIndex: {
      type: Number,
      required: true,
    },
    loopBlockIndex: {
      type: Number,
      required: true,
    },
    dragging: {
      type: Boolean,
      default: false,
    },
  });

  const getComponent = () => {
    switch (props.block.tagName) {
      case "mj-button":
        return mjloopbutton;
      case "mj-image":
        return mjloopimage;
      default:
        return mjloopktext;
    }
  };

  const render = () => {
    return createElement(getComponent(), {
      block: props.block,
      columnIndex: props.columnIndex,
      sectionIndex: props.sectionIndex,
      blockIndex: props.blockIndex,
      loopColumnIndex: props.loopColumnIndex,
      loopBlockIndex: props.loopBlockIndex,
      "data-testid": "mj-loop-" + props.block.tagName,
      name: props.block.tagName,
      key: props.block.tagName,
      class: props.block.hidden ? "hidden" : "",
      dragging: props.dragging,
    });
  };
</script>

<template>
  <render />
</template>
